/* This component READS one entry from the historys collection in MongoDB. */

import React, { useEffect, useState }        from 'react'
import axios                                 from 'axios'
import Box                                   from "@material-ui/core/Box"
import Grid                                  from "@material-ui/core/Grid"
import Paper                                 from "@material-ui/core/Paper"
import PropTypes                             from 'prop-types'
import Typography                            from "@material-ui/core/Typography"

import { CLIENT_PUBLIC_TOKEN }               from '../config'
import { node_server }                       from '../Helpers'

const HistoryReadComponent = ( { id } ) => {

   let DisplayEntry = ''

   const [ title, setTitle ]  =  useState('')

   useEffect( () => {
console.log('HistoryReadComponent useEffect')
      if (id.length > 0) {
         axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
         axios.get(node_server + `history/${id}`)
            .then( res => res.data)
            .then( data => {
               setTitle(data.history.title)
               if (data.history.entries.length > 0) {
                  DisplayEntry = data.history.entries.map( (e, i) => {
                     return(
                        <Typography key={i}>
                           { e }
                        </Typography>
                     )
               } )
               }
            })
      }
      /* Adding entry to the array causes the useEffect to render in a loop
         if the entries array has any objects in it. */
   }, [ id, title ] )

   // useEffect( () => {

   //    DisplayEntry = entry.map( (e, i) => {
   //    return(
   //       <Typography key={i}>
   //          { e }
   //       </Typography>
   //    )
   // } )

   // }, [entry] )

   return (
      <Box>
         <Grid style={{ marginTop: '5rem' }} >
            <Paper style={{ margin: '2rem', padding: '1rem', backgroundColor: 'rgba(211, 211, 211, 0.25)' }}>
               <Grid>
                  <Typography variant='h5' style={{ textAlign: 'left', marginTop: '6rem' }}>
                     {title}
                  </Typography>
               </Grid>
               <Grid>
                  { DisplayEntry }
               </Grid>
            </Paper>
         </Grid>
      </Box>
   )
}

HistoryReadComponent.propTypes = {
    id:     PropTypes.string
}

export default HistoryReadComponent
